import { useEffect, useState } from "react";

export const COOKIE_CONSENT_KEY = "kivo_cookie_consent";
export const COOKIE_CONSENT_CHANGE_EVENT = "kivo_cookie_consent_change";

export type ConsentValue = "accepted" | "essential";

export function getStoredConsent(): ConsentValue | null {
  try {
    const v = localStorage.getItem(COOKIE_CONSENT_KEY);
    if (v === "accepted" || v === "essential") return v;
  } catch {
    /* localStorage unavailable */
  }
  return null;
}

export function isAnalyticsConsented(): boolean {
  return getStoredConsent() === "accepted";
}

export function saveConsent(value: ConsentValue): void {
  try {
    localStorage.setItem(COOKIE_CONSENT_KEY, value);
    window.dispatchEvent(new Event(COOKIE_CONSENT_CHANGE_EVENT));
  } catch {
    /* localStorage unavailable */
  }
}

export function resetConsent(): void {
  try {
    localStorage.removeItem(COOKIE_CONSENT_KEY);
    window.dispatchEvent(new Event(COOKIE_CONSENT_CHANGE_EVENT));
  } catch {
    /* localStorage unavailable */
  }
}

export function useCookieConsent(): ConsentValue | null {
  const [consent, setConsent] = useState<ConsentValue | null>(getStoredConsent);

  useEffect(() => {
    const handler = () => { setConsent(getStoredConsent()); };
    window.addEventListener(COOKIE_CONSENT_CHANGE_EVENT, handler);
    return () => { window.removeEventListener(COOKIE_CONSENT_CHANGE_EVENT, handler); };
  }, []);

  return consent;
}
